import Section from "../components/Section";
import Card from "../components/Card";
function Services() {
  const services = [
    {
      title: "Design",
      desc: "Interfaces modernes et intuitives",
      imag: `${process.env.PUBLIC_URL}/assets/svg/palette.svg`,
    },
    {
      title: "Développement Frontend",
      desc: "Sites rapides et responsives",
      imag: `${process.env.PUBLIC_URL}/assets/svg/code.svg`,
    },
    {
      title: "Community Management",
      desc: "Stratégies pour engager votre audience",
      imag: `${process.env.PUBLIC_URL}/assets/svg/people-group.svg`,
    },
    {
      title: "Consulting Informatique",
      desc: "Audit et optimisation de vos systèmes",
      imag: `${process.env.PUBLIC_URL}/assets/svg/laptop-file.svg`,
    },
  ];
  return (
    <Section>
      {" "}
      <h2 className="text-3xl text-blue-600 font-bold text-center mb-8">
        <strong className=" text-orange-400"> Mes </strong>Services
      </h2>{" "}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {" "}
        {services.map((service) => (
          <Card
            image={service.imag}
            key={service.title}
            title={service.title}
            description={service.desc}
          />
        ))}{" "}
      </div>{" "}
    </Section>
  );
}
export default Services;
